import { styled } from "@mui/material/styles";
import { HubCardStack } from "../../HubCardStack";
import { Stack, Typography } from "@mui/material";
import { getBarcodeSize } from "../../../constants/barcodes";

const fontSize = 16;
const scale = 3.5;

export const BarcodeSticker = styled(HubCardStack, {
  shouldForwardProp: (prop) => !["size"].includes(prop),
})(({ size = 1 }) => ({
  ...getBarcodeSize(size),
  gap: "2px",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  padding: "5px",
  flexGrow: "0px",
  borderRadius: "5px",
  // boxShadow: "0px 0px 50px rgba(0, 0, 0, 0.2)"
  "@media print": {
    border: "0px !important",
  },
}));

export const BarcodeTypography = styled(Typography)(({ theme }) => ({
  fontSize,
  lineHeight: `${fontSize}px`,
  transform: `scaleY(${scale})`,
  textWrap: "nowrap",
}));
export const BarcodeBox = styled(Stack)({
  alignItems: "center",
  justifyContent: "center",
  height: `${fontSize * scale - 10}px`,
});

export const BarcodeDetails = styled(Stack)({
  display: "grid",
  gridTemplateColumns: "auto auto auto",
  alignContent: "center",
  width: "100%",
  padding: "0 5px",
});
